<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Jjayc3/tc-custom/9780226189970.jpg?1722570531874" alt="This image is the cover for the book New Science of Politics, Walgreen Foundation Lectures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Science of Politics, Walgreen Foundation Lectures
      </h1>
      <p class="bookDescription body article font2">
        <b>“Must be considered one of the most enlightening essays on the character of European politics that has appeared in half a century… powerful and vivid.”—<i>Times Literary Supplement</i></b><br/>  <br/> “Thirty-five years ago few could have predicted that <i>The New Science of Politics</i> would be a best-seller by political theory standards. Compressed within the Draconian economy of the six Walgreen lectures is a complete theory of man, society, and history, presented at the most profound and intellectual level…Voegelin’s [work] stands out in bold relief from much of what has passed under the name of political science in recent decades…<i>The New Science</i> is aptly titled, for Voegelin makes clear at the outset that a ‘return to the specific content’ of premodern political theory is out of the question…The subtitle of the book, <i>An Introduction</i>, clearly indicates that <i>The New Science of Politics</i> is an invitation to join the search for the recovery of our full humanity.”—From the new foreword by Dante Germino<br/><br/> “One of the most distinguished interpreters to Americans of the non-liberal streams of European thought…brilliant insights.”—<i>American Political Science Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Voegelin
      </h2>
      
      <p class="authorDescription body article">Eric Voegelin (1901-1985) was Senior Research Fellow at the Hoover Institution at the time of his death. He is the author of numerous books in addition to his major five-volume work Order and History.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d0c9c310